<template>
  <div class="input-datepicker">
    <label
      v-if="label"
      class="inline-block font-bold mb-2xs"
      for="range-from"
      v-text="t(label)"
    />
    <div class="relative">
      <input
        :value="value"
        class="w-full pointer-events-none !rounded-alt-md"
        type="text"
      />
      <div
        class="h-[32px] px-[22px] m-[1px] rounded-r-alt-md bg-background-base-opc50 absolute right-0 top-0"
      >
        <FaIcon
          classes="text-border-dark absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2"
          icon-class="fas fa-calendar-days"
        />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import FaIcon from '@/components/fa-icon.vue';
defineProps({
  label: {
    type: String,
    required: false,
    default: null,
  },
  value: {
    type: String,
    required: true,
  },
});
const { t } = useTrans();
</script>
